import React, { FC } from 'react';
import { Alert } from '@clearcover/atlas';
import { NpnStatusType } from '../NpnStatus/NpnStatus';
import styles from './styles.module.css';

const npnStatusBanners: {
  [index: string]: { message: string; type: 'error' | 'info' };
} = {
  invalid: {
    message:
      "The NPN you entered is invalid. Please confirm your entry and try again. If the NPN is correct, contact the user's agency admin for assistance.",
    type: 'error',
  },
  sync_in_progress: {
    message: "We're verifying this user's NPN. This may take a few minutes.",
    type: 'info',
  },
  syncing_error: {
    message:
      "The NPN you entered can't be verified at this time. Please try again later.",
    type: 'error',
  },
  unknown: {
    message: "We're verifying this user's NPN. This may take a few minutes.",
    type: 'info',
  },
};

type NpnStatusBannerProps = {
  npnStatus: NpnStatusType;
};

export const NpnStatusBanner: FC<NpnStatusBannerProps> = ({ npnStatus }) => {
  if (!npnStatusBanners.hasOwnProperty(npnStatus)) return null;

  const npnStatusBanner = npnStatusBanners[npnStatus];

  return (
    <div className={styles.npnBanner}>
      <Alert
        message={npnStatusBanner.message}
        type={npnStatusBanner.type}
      ></Alert>
    </div>
  );
};
